"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MartianMediaCenter = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const Resources_1 = require("../../Resources");
const SelectHowToPayDeferred_1 = require("../../deferredActions/SelectHowToPayDeferred");
const SendDelegateToArea_1 = require("../../deferredActions/SendDelegateToArea");
const CardRequirements_1 = require("../CardRequirements");
const CardRenderer_1 = require("../render/CardRenderer");
const constants_1 = require("../../constants");
const TurmoilHandler_1 = require("../../turmoil/TurmoilHandler");
const Turmoil_1 = require("../../turmoil/Turmoil");
const Units_1 = require("../../Units");
class MartianMediaCenter extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.MARTIAN_MEDIA_CENTER,
            tags: [Tags_1.Tags.BUILDING],
            cost: 7,
            productionBox: Units_1.Units.of({ megacredits: 2 }),
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.party(PartyName_1.PartyName.MARS)),
            metadata: {
                cardNumber: 'T07',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Pay 3 M€ to add a delegate to any party.', (eb) => {
                        eb.megacredits(3).startAction.delegates(1);
                    }).br;
                    b.production((pb) => {
                        pb.megacredits(2);
                    });
                }),
                description: 'Requires that Mars First is ruling or that you have 2 delegates there. Increase your M€ production 2 steps.',
            },
        });
    }
    canPlay(player) {
        const turmoil = Turmoil_1.Turmoil.getTurmoil(player.game);
        if (turmoil.parties.find((p) => p.name === PartyName_1.PartyName.MARS)) {
            return turmoil.canPlay(player, PartyName_1.PartyName.MARS);
        }
        Card_1.Card.setSocietyWarningText(this, PartyName_1.PartyName.MARS);
        return player.canAfford(player.getCardCost(this) + constants_1.SOCIETY_ADDITIONAL_CARD_COST);
    }
    play(player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, 2);
        TurmoilHandler_1.TurmoilHandler.handleSocietyPayment(player, PartyName_1.PartyName.MARS);
        return undefined;
    }
    canAct(player) {
        return player.canAfford(3) && player.game.turmoil.hasAvailableDelegates(player.id);
    }
    action(player) {
        player.game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(player, 3, { title: 'Select how to pay for Martian Media Center action' }));
        player.game.defer(new SendDelegateToArea_1.SendDelegateToArea(player, 'Select where to send a delegate', { source: 'reserve' }));
        return undefined;
    }
}
exports.MartianMediaCenter = MartianMediaCenter;
//# sourceMappingURL=MartianMediaCenter.js.map